import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useRecords } from '@/shared/hooks'
import { useResourceContext } from '@/shared/ui/Resource'

import { DigitalProductStoreBottomSheetRewardRequest } from './RewardRequest'
import { useDigitalProductStore } from '../../hook'

export const DigitalProductStoreBottomSheetRewardRequests = () => {
  const {
    id,
    rewardRequestsWithCanceled,
    refetchRewardRequests,
    isLoadingRewardRequests
  } = useResourceContext()

  const { digitalProductId, progress } = useDigitalProductContext()

  const { claim, polling } = useDigitalProductStore()

  if (!isLoadingRewardRequests && rewardRequestsWithCanceled.length === 0)
    return null

  return (
    <div className="flex flex-col gap-3">
      <p>
        <strong>Seus resgastes deste item:</strong>
      </p>
      <div className="flex flex-col gap-6">
        {rewardRequestsWithCanceled.map((request, index) => (
          <DigitalProductStoreBottomSheetRewardRequest
            key={index}
            {...request}
            onWithdraw={refetchRewardRequests}
          />
        ))}
      </div>
    </div>
  )
}
